import { Component, ComponentChild, h } from 'preact'
import Panel from '../../control-components/panel'
import ButtonControl from '../button-control'
import { Modal, ModalHeader, ModalBody } from '../modal/'
import AlertComponent from '../../control-components/ui-components/AlertComponent'
import InputGroup from '../../control-components/ui-components/InputGroup'
import DynamicImport from '../utils/DynamicImport'
const CodeMirror = DynamicImport(async () => await import('../../control-components/codemirror/index'))

interface Props {
  content: string
  title: string
  onChange: (state: {html: string, title: string}) => void
  deleteButtonAction: () => void
  hideDeleteButton?: boolean
}

interface State {
  content: string
  title: string
  showModal: boolean
  isError: boolean
}

export class HTMLWidget extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      content: props.content || '',
      showModal: false,
      isError: false,
      title: props.title
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleModalToggle = this.handleModalToggle.bind(this)
    this.handleCloseNotification = this.handleCloseNotification.bind(this)
    this.handleDeleteButton = this.handleDeleteButton.bind(this)
  }

  handleChange (data: string) {
    this.props.onChange({
      html: data,
      title: this.state.title
    })

    this.setState({
      content: data
    })
  }

  handleTitleChange (data: string) {
    this.props.onChange({
      html: this.state.content,
      title: data
    })

    this.setState({
      title: data
    })
  }

  handleModalToggle () {
    this.setState({
      showModal: !this.state.showModal
    })
  }

  handleCloseNotification () {
    this.setState({
      isError: false
    })
  }

  handleDeleteButton () {
    this.props.deleteButtonAction()
    this.handleModalToggle()
  }

  render (_: Props, {
    content,
    showModal,
    isError
  }: State) {
    const options = {
      lineNumbers: true,
      mode: 'text/html',
      selectionPointer: true,
      autoRefresh: true,
      autoResize: true
    }

    return (
      <div>
        {isError && <AlertComponent
          messageType='error'
          message=''
          renderHTML
          onClose={this.handleCloseNotification}
                    />}

        <form class='html-widget__form'>
          <InputGroup
            title='Title'
            type='text'
            onChange={(e: ChangeEvent) => { this.handleTitleChange(e.target.value) }}
            value={this.state.title}
          />

          <CodeMirror
            defaultValue={content}
            onChange={this.handleChange}
            options={options}
          />
        </form>
        {
          !this.props.hideDeleteButton && (
            <ButtonControl
              variant='warning'
              title='Delete'
              onClick={this.handleModalToggle}
            />
          )
        }
        <Modal
          isOpen={showModal}
          size='medium'
        >
          <ModalHeader
            title='Delete HTML Widget?'
            onClose={this.handleModalToggle}
          />
          <ModalBody>
            <p>If you delete this widget, it's gone for good.</p>
            <ButtonControl
              variant='danger'
              title='Delete'
              onClick={this.handleDeleteButton}
            />
            <ButtonControl
              variant='secondary'
              title='Cancel'
              onClick={this.handleModalToggle}
            />
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

interface PanelProps extends Props {
  switcher?: ComponentChild
  dragHandle: ComponentChild
}

const HTMLWidgetPanel = (props: PanelProps) => {
  return (
    <Panel
      collapsible
      customClass='homepage-widget homepage-widget--html'
      title={
        <div className='panel-title-with-switch'>
          <div className='homepage-reorderable-panel-title'>
            {props.dragHandle}
            <span>HTML widget</span>
          </div>
          {props.switcher}
        </div>
    }
    >
      <HTMLWidget {...props} />
    </Panel>
  )
}

export default HTMLWidgetPanel
